import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export default function useHoldToRevealPreviousImage(currentUrl, { resetKey } = {}) {
  const lastUrlRef = useRef(null);
  const [previousUrl, setPreviousUrl] = useState(null);
  const [isHoldingPrevious, setIsHoldingPrevious] = useState(false);

  useEffect(() => {
    lastUrlRef.current = null;
    setPreviousUrl(null);
    setIsHoldingPrevious(false);
  }, [resetKey]);

  useEffect(() => {
    if (!currentUrl) return;
    if (currentUrl === lastUrlRef.current) return;

    if (lastUrlRef.current) {
      setPreviousUrl(lastUrlRef.current);
    }

    lastUrlRef.current = currentUrl;
  }, [currentUrl]);

  const stopHold = useCallback((event) => {
    if (!isHoldingPrevious) return;

    const el = event?.currentTarget;
    if (el?.releasePointerCapture && typeof event?.pointerId === 'number') {
      try {
        el.releasePointerCapture(event.pointerId);
      } catch (_) {
        // ignore
      }
    }

    setIsHoldingPrevious(false);
  }, [isHoldingPrevious]);

  const startHold = useCallback((event) => {
    if (!previousUrl) return;

    const el = event?.currentTarget;
    if (el?.setPointerCapture && typeof event?.pointerId === 'number') {
      try {
        el.setPointerCapture(event.pointerId);
      } catch (_) {
        // ignore
      }
    }

    setIsHoldingPrevious(true);
  }, [previousUrl]);

  const bind = useMemo(() => ({
    onPointerDown: startHold,
    onPointerUp: stopHold,
    onPointerCancel: stopHold,
    onPointerLeave: stopHold
  }), [startHold, stopHold]);

  const displayUrl = isHoldingPrevious && previousUrl ? previousUrl : currentUrl;

  return {
    bind,
    displayUrl,
    isHoldingPrevious,
    previousUrl,
    hasPrevious: Boolean(previousUrl)
  };
}

